var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"text-center"},[_vm._v("La página que buscas no se encuentra disponible.")]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("VOLVER")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }